import Button from 'atoms/Button';
import cn from 'classnames';
import React from 'react';
import { navigateToUrl } from 'utils/navigateUtils';
import { generateRandomString } from 'utils/urlUtils';

import s from './Navigation.module.scss';

interface ISignUpNav {
  name: string;
  transparent: boolean;
  dark: boolean;
  isSticky?: boolean;
}

const SignUpNav = ({ name, transparent, dark, isSticky }: ISignUpNav) => {
  return (
    <Button
      className={cn(s.Navigation__btn, s.Navigation__signup__btn, {
        transparent,
        dark,
        isSticky
      })}
      onClick={() => navigateToUrl('/connect/signUp', { query: { tk: generateRandomString(4) } })}
    >
      {name}
    </Button>
  );
};

export default SignUpNav;
